import { FormValidationMessages } from "../models/form-validation.interface";
import { VALIDATOR_KEYS } from "./form-validation-keys.constants";

export const FORM_VALIDATION_MESSAGES: FormValidationMessages = {
    name: {
        hint: "Enter your full name",
        errors: {
            [VALIDATOR_KEYS.required]: "Name field is mandatory.",
            [VALIDATOR_KEYS.forbiddenName]: "Name cannot contain numbers or special characters.",
        },
    },
    email: {
        hint: "Enter your email",
        errors: {
            [VALIDATOR_KEYS.required]: "Email field is mandatory.",
            [VALIDATOR_KEYS.email]: "Please use a valid email format.",
        },
    },
    age: {
        hint: "Enter your age",
        errors: {
            [VALIDATOR_KEYS.required]: "Age field is mandatory.",
            [VALIDATOR_KEYS.digitsOnly]: "Please enter a valid age.",
        },
    },
    houseNumber: {
        hint: "Enter your house number",
        errors: {
            [VALIDATOR_KEYS.required]: "House number field is mandatory.",
        },
    },
    pincode: {
        hint: "Enter your pincode",
        errors: {
            [VALIDATOR_KEYS.required]: "Pincode field is mandatory.",
            [VALIDATOR_KEYS.invalidPincode]: "Please enter a valid pincode.",
        },
    },
    address: {
        hint: "Enter your address",
        errors: {
            [VALIDATOR_KEYS.required]: "Address field is mandatory.",
        },
    },
    city: {
        hint: "Enter your city",
        errors: {
            [VALIDATOR_KEYS.required]: "City field is mandatory.",
        },
    },
    state: {
        hint: "Enter your state",
        errors: {
            [VALIDATOR_KEYS.required]: "State field is mandatory.",
        },
    },
    addressType: {
        hint: "Select your address type",
        errors: {
            [VALIDATOR_KEYS.required]: "Address type field is mandatory.",
        },
    },
};

export type FieldKey = keyof typeof FORM_VALIDATION_MESSAGES;
